import { Logo } from "@/components/Logo";

const S = ({ t, children }) => (<section className="mt-8"><h2 className="font-display text-lg font-bold text-stone-900">{t}</h2><div className="mt-2 space-y-2 text-sm leading-relaxed text-stone-700">{children}</div></section>);

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="mx-auto max-w-3xl px-5 py-10 pt-[calc(env(safe-area-inset-top)+2.5rem)]">
      <Logo />
      <h1 className="mt-10 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Privacy policy</h1>
      <p className="mt-2 text-sm text-stone-500">Applies to the VirtuForce website and the VirtuForce iOS and Android apps.</p>
      <S t="What we collect">
        <p>Account details (name, email, phone, company), business and candidate profile information, messages, hire, interview and offer records, signed contracts, and files you upload, such as resumes, licences and business documents.</p>
        <p>In the mobile apps: a push notification token (if you allow notifications), and photos or files only when you choose to take or attach them. Face ID and fingerprint checks happen on your device. We never receive your biometric data.</p>
      </S>
      <S t="How we use it">
        <p>To run your account, match businesses with candidates, deliver messages and notifications, prepare contracts, and process payments. Card payments are handled by Stripe. We never see or store your full card number.</p>
      </S>
      <S t="Who can see it">
        <p>Our recruitment team can see what's in your account. Private files stay private unless you share them or approve a document request. We don't sell your data.</p>
      </S>
      <S t="Your choices">
        <p>You can update your details at any time. You can delete your account from <b>Account → Delete my account</b> in the app or on the website, or by messaging our team. Records we must keep by law, such as signed contracts and payment records, may be retained.</p>
      </S>
      <S t="Contact">
        <p>Questions? Message our team from your portal.</p>
      </S>
    </div>
  );
}
